// UI
import { useBreakpointValue } from '@chakra-ui/react'

function useCheckIsSmallScreen() {
  const isSmallScreen = useBreakpointValue({ base: true, '2xs': true, md: true, lg: false })

  return { isSmallScreen }
}

export default useCheckIsSmallScreen
